import Search from 'antd/es/input/Search'
import React, { useEffect, useState } from 'react'

function SearchComponent({ onFilter, masterData, filterByKeys }) {
    const [searchText, setSearchText] = useState("");
    const [placeholder, setPlaceholder] = useState("");

    useEffect(() => {
        filterContent();
    }, [searchText, masterData])

    useEffect(() => {
        setPlaceholder("Filter by " + filterByKeys.join(','))
    }, [filterByKeys])

    const filterContent = () => {
        const master = masterData;

        const filtered = master.map(item => ({ ...item, key: item.id })).filter(data => {
            return filterByKeys.some(key =>
                data[key]?.toString().toLowerCase().includes(searchText.toString().toLowerCase())
            );
        });

        onFilter(filtered);
    }



    return (
        <div>
            <Search 
                placeholder={placeholder}
                onChange={(event) => {
                    setSearchText(event.target.value)
                }} 
            />
        </div>
    )
}

export default SearchComponent